import React from 'react'

import { InventoryShipment } from '@components/common/InventoryShipment/InventoryShipment'
import { useInventoryShipmentsQuery } from '@components/hooks/useInventoryShipmentsQuery'
import { Button } from '@fourthwall/components'
import { routing } from '@utils/routing'

import * as S from './InventoryShipmentSection.styled'

export const InventoryShipmentSection = () => {
  const { inventoryShipmentsQuery } = useInventoryShipmentsQuery()

  if (!inventoryShipmentsQuery.data || inventoryShipmentsQuery.data.length === 0) {
    return (
      <S.EmptyState>
        <p>You don’t have any inventory shipments yet.</p>
        <Button
          to={routing.settings.shipping.inventoryShipments.create}
          label="Send inventory to our fulfillment center"
          appearance="secondary"
          fullWidth={false}
        />
      </S.EmptyState>
    )
  }

  return (
    <InventoryShipment
      data={inventoryShipmentsQuery.data || []}
      isLoading={inventoryShipmentsQuery.isLoading}
    />
  )
}
